// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Une feuille a trois lignes de texte : un fichier texte. Source text-file.
 *
 * Fournie par le fondateur le 08/10/2026,
 * exportee en traces Potrace : cadre `0 0 240 240`, traces en dixiemes et
 * retournes (`translate(0 240) scale(.1 -.1)`), recopies tels quels.
 */
export const IconTextFile = createCustomIcon(
  'IconTextFile',
  '0 0 240 240',
  <>
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M200 1200 l0 -1200 1000 0 1000 0 0 913 0 912 -288 288 -287 287 -713 0 -712 0 0 -1200z m1537 738 l213 -213 0 -737 0 -738 -750 0 -750 0 0 950 0 950 537 0 538 0 212 -212z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M700 1750 l0 -130 250 0 250 0 0 130 0 130 -250 0 -250 0 0 -130z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M700 1200 l0 -130 500 0 500 0 0 130 0 130 -500 0 -500 0 0 -130z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M700 650 l0 -130 500 0 500 0 0 130 0 130 -500 0 -500 0 0 -130z" />
  </>,
);
